module.exports = __webpack_public_path__ + "img/1500842795.a163ea1e.jpg";